import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsStrip = () => {
  const metrics = [
    {
      id: 'success-rate',
      title: 'Treatment Success Rate',
      value: '87.3%',
      change: '+5.2%',
      trend: 'up',
      description: 'Pest reduction effectiveness',
      confidence: '95% CI: 84.1-90.5%'
    },
    {
      id: 'cost-per-acre',
      title: 'Cost per Acre',
      value: '$42.15',
      change: '-8.7%',
      trend: 'down',
      description: 'Average treatment cost',
      confidence: 'vs. industry avg: $48.20'
    },
    {
      id: 'pest-reduction',
      title: 'Pest Reduction',
      value: '73.8%',
      change: '+12.4%',
      trend: 'up',
      description: 'Population decrease',
      confidence: 'Measured over 14 days'
    },
    {
      id: 'roi',
      title: 'Treatment ROI',
      value: '284%',
      change: '+18.9%',
      trend: 'up',
      description: 'Return on investment',
      confidence: 'Based on yield protection'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-8">
      {metrics?.map((metric) => (
        <div key={metric?.id} className="bg-card rounded-lg border border-border p-6 agricultural-shadow">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <h3 className="text-sm font-medium text-muted-foreground mb-1">
                {metric?.title}
              </h3>
              <div className="text-3xl font-bold text-foreground mb-1">
                {metric?.value}
              </div>
              <p className="text-xs text-muted-foreground">
                {metric?.description}
              </p>
            </div>
            <div className={`
              flex items-center space-x-1 px-2 py-1 rounded-md text-xs font-medium
              ${metric?.trend === 'up' ?'bg-success/10 text-success' :'bg-warning/10 text-warning'
              }
            `}>
              <Icon 
                name={metric?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                size={14} 
              />
              <span>{metric?.change}</span>
            </div>
          </div>
          <div className="text-xs text-muted-foreground border-t border-border pt-3">
            {metric?.confidence}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsStrip;